// Maps a cached order (as loaded by the Delivery Log) into the shape PodReceiptCard
// expects — the same shape the public `GET /pod/{id}` endpoint returns online. Lets
// the offline receipt reuse the exact receipt layout with no fetch and no token.
// Driver falls back to the confirming driver on the confirmation (already on the
// order). Protected media is loaded separately through authenticated business
// routes so this adapter never receives repository or filesystem identity.
export function adaptOrderToReceipt(order) {
  const o = order || {};
  const confirmation = o.delivery_confirmation || {};
  return {
    internal_order_number: o.internal_order_number,
    recipient_name: o.recipient_name,
    recipient_street_address: o.recipient_street_address,
    recipient_street_address_2: o.recipient_street_address_2,
    recipient_city: o.recipient_city,
    recipient_state: o.recipient_state,
    recipient_zip_code: o.recipient_zip_code,
    delivery_date: o.delivery_date,
    resolved_source: o.resolved_source,
    source_resolution_status: o.source_resolution_status,
    driver_name: confirmation.assigned_driver_name_at_delivery
      || confirmation.confirmed_by_user_name,
    has_arrangement_photo: Boolean(o.arrangement_photo?.storage_path),
    confirmation,
  };
}
